import React from 'react';
import './gameUi.css';
import {getPlayerColorStyle} from '../../utils/gameUi/getPlayerColorStyle';
import {joinClassNames} from './joinClassNames';

/**
 * Рамка цвета игрока вокруг выбранного жетона. Цвет — --gui-pc ближайшего
 * предка (getPlayerColorStyle на кнопке)
 */
export function HexButtonFrame({className}) {
  return <span className={joinClassNames('gui-hex-button_frame', className)} aria-hidden={true}/>;
}

/**
 * Гекс-кнопка: жетон с игрового поля (постройка, отряд) как кнопка тулбара.
 * Без картинки — каменный гекс, внутрь кладется иконка (children)
 * @param {string} [src] - картинка жетона
 * @param {string} alt - подпись для скринридера
 * @param {boolean} [selected] - выбранный жетон: приподнят, рамка цвета игрока
 * @param {string} [playerColor] - цвет рамки выбранного жетона
 * @param {number} [width] - ширина гекса в px (высота — по пропорции гекса)
 */
export function HexButton({
  src,
  alt,
  selected = false,
  playerColor,
  width,
  type = 'button',
  className,
  style,
  children,
  ...rest
}) {
  return (
    <button
      type={type}
      className={joinClassNames(
        'gui-hex-button',
        !src && 'gui-hex-button_stone',
        selected && 'gui-hex-button_selected',
        className,
      )}
      aria-label={alt}
      aria-pressed={selected}
      style={{
        ...getPlayerColorStyle(playerColor),
        ...(width ? {'--gui-hex-w': `${width}px`} : null),
        ...style,
      }}
      {...rest}
    >
      {src ? <img src={src} alt={''} draggable={false}/> : children}
      {selected && <HexButtonFrame/>}
    </button>
  );
}

export default HexButton;
